import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const EditInstituteModal = ({ show, handleClose, institute }) => {
  const [updatedInstitute, setUpdatedInstitute] = useState({
    name: '',
    address: '',
    pincode: '',
  })

  useEffect(() => {
    if (institute) {
      setUpdatedInstitute({
        name: institute.name || '',
        address: institute.address || '',
        pincode: institute.pincode || '',
      })
    }
  }, [institute])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedInstitute((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.editInstitute(
        institute.institute_id,
        updatedInstitute,
      )
      toast.success(response.data.message)
      handleClose()
    } catch (error) {
      toast.error(error.response?.message || 'Something wents wrong.')
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Institute</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Class Name Field */}
          <Form.Group className="mb-3">
            <Form.Label>Institute Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={updatedInstitute.name}
              onChange={handleInputChange}
              placeholder="Enter Institute Name"
              className="p-2 border rounded"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="textarea"
              name="address"
              value={updatedInstitute.address}
              onChange={handleInputChange}
              placeholder="Enter Address"
              className="p-2 border rounded"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Pincode</Form.Label>
            <Form.Control
              type="number"
              name="pincode"
              value={updatedInstitute.pincode}
              onChange={handleInputChange}
              placeholder="Enter Pincode"
              className="p-2 border rounded"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditInstituteModal
